module.exports = __webpack_public_path__ + "img/learning-consultation.58d65f97.svg";